





























import { Component, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { IPartner } from "@/types/partner";

@Component({
  components: {},
})
export default class extends Vue {
  @Getter("partner/single")
  public partner!: IPartner;

  @Action("progress/flipStatus")
  public progress!: (progress_id: number) => Promise<boolean>;

  @Action("partner/salesGet")
  public getPartner!: (id: number) => void;

  public partner_id = 0;

  public created() {
    this.partner_id = Number(this.$route.params.partner_id);
  }

  public async updateProgress(id: number) {
    await this.progress(id);
    await this.getPartner(this.partner_id);
  }
}
